export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8357.79d5d896.jpg";